// pages/PostDetailPage.jsx
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useGetPostByIdQuery } from "../store/api/postApi";
import Post from "../components/Post";
import styles from "./PostDetailPage.module.css";
import Header from "./Header";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useSelector } from "react-redux";
import JoinBanner from "./JoinBanner";

export default function PostDetailPage() {
  const { userId: loggedInUserId } = useAuth();
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated ?? false);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "Post";
  const { id } = useParams();

  const location = useLocation();
  const navigate = useNavigate();

  const {
    data: post,
    isLoading,
    isError,
  } = useGetPostByIdQuery({ postId: id, type }, { skip: !id });

  if (isLoading) {
    return (
      <div className={styles.centered}>
        <div className={styles.spinner} />
        <p>Loading post...</p>
      </div>
    );
  }

  if (isError || !post) {
    return (
      <div className={styles.centered}>
        <p className={styles.errorText}>
          Post not found or may have been deleted.
        </p>
        {isAuthenticated && (
          <button
            className={styles.backBtn}
            onClick={() => {
              if (location.key !== "default") {
                navigate(-1);
              } else {
                navigate("/", { replace: true });
              }
            }}
          >
            ← Go Back
          </button>
        )}
      </div>
    );
  }

  const postOwnerId =
    post?.type === "SharedPost" ? post?.sharedBy?.id : post?.user?.id;

  return (
    <>
      <Header />
      {isAuthenticated && (
        <div className={styles.topBar}>
          <button
            className={styles.backBtn}
            onClick={() => {
              if (location.key !== "default") {
                navigate(-1);
              } else {
                navigate("/", { replace: true });
              }
            }}
          >
            ← Back
          </button>
        </div>
      )}

      <div className={styles.postWrapper}>
        {/* ✅ Reuses your existing Post component */}
        <Post
          post={post}
          isOwner={postOwnerId === loggedInUserId}
          openComments={true}
          disableNavigation={true}
        />
      </div>
      {!isAuthenticated && <JoinBanner />}
    </>
  );
}